import { ActionKeys } from '~/actions/constants';
import { ActionTypes } from '~/actions/index';
import { SeverityType } from '~/components/SnackbarAlert/types';

export interface SnackbarState {
  id: number;
  message: string | null;
  i18n: boolean;
  severity: SeverityType;
}

export const initialState: SnackbarState = {
  id: 0,
  message: null,
  i18n: false,
  severity: 'success',
};

function snackbarReducer(state: SnackbarState = initialState, action: ActionTypes) {
  switch (action.type) {
    case ActionKeys.SNACKBAR_ADD_MESSAGE:
      return {
        ...state,
        id: state.id + 1,
        message: action.payload.message,
        i18n: action.payload.i18n,
        severity: action.payload.severity,
      };
    default:
      return state;
  }
}

export default snackbarReducer;
